<script>
    let className = '';

    export { className as class };
    export let currency;
    export let selectedChip;
    export let chipPrice;
    export let decimal;
</script>

<span class="font-bold {className}">
    {currency}
    {Number(Number(selectedChip) * Number(chipPrice)).toFixed(decimal)}
</span>
